<template>
  <div>
    <div v-for="(item, index) in inputValues" :key="index" class="input-row">
      <div class="input-item">
        <el-input
          placeholder="邀请人数"
          v-model="item.key"
          @input="handleChange"
          :disabled="disabled"
        ></el-input>
        <el-input
          placeholder="奖励百分比(0-1之间)"
          v-model="item.value"
          @input="handleChange"
          :disabled="disabled"
        ></el-input>
      </div>
      <el-button
        v-if="index"
        type="primary"
        icon="el-icon-minus"
        circle
        @click="removeInput(index)"
      ></el-button>
    </div>
    <el-button
      type="primary"
      icon="el-icon-plus"
      circle
      @click="addInput"
    ></el-button>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
export default {
  name: 'mutipleInput',
  props: ['value', 'disabled'],
  data() {
    return {
      inputValues:
        this.value && this.value.length
          ? this.value.concat()
          : [{ key: '', value: '' }],
      newPair: ''
    };
  },
  computed: {
    // ...mapState('airdrop', ['coinTypeList']),
  },
  watch: {
    value: {
      handler(val, oldVal) {
        this.inputValues =
          val && val.length ? val.concat() : [{ key: '', value: '' }];
      },
      deep: true
    }
  },
  methods: {
    handleChange() {
      this.$emit('change', this.inputValues);
      this.$emit('input', this.inputValues);
      this.$parent.$emit('el.form.change', this.inputValues);
    },
    addInput() {
      this.inputValues.push({ key: '', value: '' });
    },
    removeInput(index) {
      this.inputValues.splice(index, 1);
    }
  }
};
</script>

<style lang="less" scoped>
.input-row {
  margin-bottom: 10px;
  display: flex;
}
.el-input {
  width: auto;
}
.recommand {
  margin-left: 10px;
  font-size: 13px;
}
</style>
